module.exports = __webpack_public_path__ + "img/ring_g_0_1_null@2x.a2b748ae.png";